import { Component } from '@angular/core';
import { ReportService } from '../../../services';
import { UserService } from '../../../services';
import { BaseReportComponent } from '../base-report.component';
import { VmeInboxJobsService } from '../../../services';

@Component({
  selector: 'supplier-unassignment-report',
  templateUrl: './supplier-unassignment-report.component.html',
})
export class SupplierUnassignmentReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public customers: any[] = [];
  public suppliers: any[] = [];

  constructor(
    reportService: ReportService<any, any>,
    private userService: UserService,
    private vmeInboxjobsService: VmeInboxJobsService,
  ) {
    super(reportService, true);
    reportService.url = '/api/report/supplierUnassigned';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();

    this.vmeInboxjobsService.getCustomers().then((res) => {
      let l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.customers = l;
      this.customers.unshift({ label: 'Please Select', value: null });
    });

    this.vmeInboxjobsService.getSuppliers().then((res) => {
      let l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.suppliers = l;
      this.suppliers.unshift({ label: 'Please Select', value: null });
    });
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    /*

    if (this._filterParam) {
      if (this._filterParam.customers) {
        this.customers.push({ label: 'Please Select', value: null });
        this._filterParam.customers.sort(x => x.id).forEach(x => {
          this.customers.push({ label: x.name, value: x.id });
        });
      }

      if (this._filterParam.suppliers) {
        this.suppliers.push({ label: 'Please Select', value: null });
        this._filterParam.suppliers.sort(x => x.id).forEach(x => {
          this.suppliers.push({ label: x.name, value: x.id });
        });
      }
    }
     */
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        unassignedDateFrom: {},
        unassignedDateTo: {},
        customerId: {},
        supplierId: {},
        orderNumber: {},
        jobNumber: {},
      },
    };
  }
}
